
// Exercise Actions
export const Fetch_Exercise_Success = 'Fetch_Exercise_Success';

export const Fetch_Exercise_Failed = 'Fetch_Exercise_Failed';

export const Fetch_Exercise_Loading = 'Fetch_Exercise_Loading';

export const Create_Exercise = 'Create_Exercise'

export const Delete_Exercise = 'Delete_Exercise'

// Regimen Actions

export const Fetch_Regimen = 'Fetch_Regimen'

export const Create_Regimen = 'Create_Regimen'

export const Delete_RegimenEx = 'Delete_RegimenEx'

export const Update_Regimen = 'Update_Regimen'

export const UnComplete = 'UnComplete'

export const Create_TempRegName = 'Create_TempRegName'

export const Clear_TempRegName = 'Clear_TempRegName'

export const Set_UserId = 'Set_UserId'

export const Create_Log = 'Create_Log'

export const Fetch_Logs = 'Fetch_Logs'
